/**
 * @prettier
 */

global.jQuery = require('jquery')

window.$ = jQuery

require('vendor/javascripts/reveal')
require('./widget/walkthrough')

let message = $('.js-message')
let timer

let displayNotice = function (data, delay) {
  clearTimeout(timer)
  message.html(data).slideDown(300)
  timer = setTimeout(
    function () {
      message.slideUp(300)
    },
    delay ? delay : 5000,
  )
}

$(document).on('submit.default', 'form.js-enterprise-feedback', function (event) {
  event.preventDefault()

  let beforeSend = $('.js-feedback-before')
  let afterSend = $('.js-feedback-after')
  let formErrors = []
  let errorMessage = ''

  if (formErrors.length) {
    errorMessage = formErrors.join(', ')
    displayNotice(errorMessage)

    return false
  }

  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: $(event.target).attr('action'),
    data: $(event.target).serializeArray(),
    success(data, textStatus, jqXHR) {
      console[data.success ? 'info' : 'error'](data.message)
      if (data.success) {
        if (window.ga) {
          ga('send', 'event', 'Walkthrough Sales Inquiry Form is submitted', 'submitted')
        }
        beforeSend.slideUp(300)
        setTimeout(function () {
          afterSend.slideDown(300)
        }, 300)
      } else {
        message.html(data.message).slideDown(300)
      }
    },
  })
})
